import styled from 'styled-components'

const SectionItemTitle = styled.label`
  color: #f6f6f7;
  font-size: 16px;
  line-height: 24px;
  word-wrap: break-word;
`

export default SectionItemTitle
